import { create } from '@bufbuild/protobuf'
import { AdminListOrganizationBillingRequestSchema } from '@/gen/cortado/v1/admin_pb'
import { BillingAccessStateEnum, PlanKeyEnum } from '@/gen/cortado/v1/subscriptions_pb'

/** Matches the backend default for AdminListOrganizationBilling. */
export const ORG_BILLING_OVERVIEW_PAGE_SIZE = 50

export function orgBillingPageToken(
  pageIndex: number,
  pageSize = ORG_BILLING_OVERVIEW_PAGE_SIZE,
): string | undefined {
  if (pageIndex <= 0 || pageSize <= 0) return undefined
  return String(pageIndex * pageSize)
}

export function buildOrgBillingOverviewRequest(input: {
  stateFilter: string
  planFilter: string
  pageIndex: number
  pageSize?: number
}) {
  const pageSize = input.pageSize ?? ORG_BILLING_OVERVIEW_PAGE_SIZE
  return create(AdminListOrganizationBillingRequestSchema, {
    state:
      input.stateFilter === 'all'
        ? undefined
        : (Number(input.stateFilter) as BillingAccessStateEnum),
    planKey:
      input.planFilter === 'all'
        ? undefined
        : (Number(input.planFilter) as PlanKeyEnum),
    pageSize,
    pageToken: orgBillingPageToken(input.pageIndex, pageSize),
  })
}

export function orgBillingPagerState(input: {
  pageIndex: number
  nextPageToken?: string
  isFetching: boolean
}): { hasPrevPage: boolean; hasNextPage: boolean; prevDisabled: boolean; nextDisabled: boolean } {
  const hasPrevPage = input.pageIndex > 0
  const hasNextPage = Boolean(input.nextPageToken)
  return {
    hasPrevPage,
    hasNextPage,
    prevDisabled: !hasPrevPage || input.isFetching,
    nextDisabled: !hasNextPage || input.isFetching,
  }
}

export function orgBillingOverviewRangeLabel(input: {
  pageIndex: number
  pageSize: number
  rowCount: number
  totalCount: number
}): string {
  if (input.totalCount <= 0 || input.rowCount <= 0) return ''
  const start = input.pageIndex * input.pageSize + 1
  const end = input.pageIndex * input.pageSize + input.rowCount
  const noun = input.totalCount === 1 ? 'organization' : 'organizations'
  return `Showing ${start}–${end} of ${input.totalCount} ${noun}`
}
